import {useDebugValue} from 'react';

import {getNoUndefObject} from '../../../utils';

function useTranslations(defaultTranslations, ...otherTranslations) {
    const specifiedTranslations = otherTranslations.reduce((accumulatedTranslations, currentTranslations) => ({
        ...accumulatedTranslations,
        ...getNoUndefObject(currentTranslations)
    }), {});

    const translations = {
        ...defaultTranslations,
        ...specifiedTranslations
    };

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useTranslations};
